import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Checkbox, Col, Row, Spin} from 'antd';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import TextArea from 'antd/es/input/TextArea';

interface ManageFaqProps {
  faqId?: string | null;
}

const ManageFaq: React.FC<ManageFaqProps> = ({faqId}) => {
  const [FaqQuestion, setFaqQuestion] = useState('');
  const [FaqAnswer, setFaqAnswer] = useState('');
  const [FaqShortName, setFaqShortName] = useState('');
  const [IsFaqShortNameVisible, setIsFaqShortNameVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false); // Loading state

  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
        if (faqId != null) {
            loadFaqDataForEdit(faqId);
        }
      }, []);
      
    const loadFaqDataForEdit = async (faqId: string) => {
        try {
          const token = await fetchToken();
          const response = await axios.get(`${API_URL}/api/Faq/GetFaqById/${faqId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          console.log(response.data);
          setFaqQuestion(response.data.faqQuestion);
          setFaqAnswer(response.data.faqAnswer);
          setFaqShortName(response.data.faqShortName && response.data.faqShortName.trim() !== '' ? response.data.faqShortName : null);
          setIsFaqShortNameVisible(
            response.data.isShortNameVisible === null || response.data.isShortNameVisible === undefined
              ? false
              : response.data.isShortNameVisible
          );
        } catch (error) {
          console.error("Error fetching faq details", error);
        }
    };

  const handleSubmit = async () => {
    if (!FaqQuestion || !FaqAnswer) {
      message.error('Please fill all fields');
      return;
    }   
    // Custom validation for FaqShortName and IsFaqShortNameVisible
    if ((FaqShortName && !IsFaqShortNameVisible) || (!FaqShortName && IsFaqShortNameVisible)) {
      message.error('Both "FAQ Short Name" and "Short Name Visible" must be filled if either is provided.');
      return;
    }
    
    setLoading(true); // Start loading

    const userId = localStorage.getItem("UserId");

    const formData = new FormData();
    formData.append('FaqQuestion', FaqQuestion);
    formData.append('FaqAnswer', FaqAnswer);
    formData.append('FaqShortName', FaqShortName && FaqShortName.trim() !== '' ? FaqShortName : '');
    formData.append('IsShortNameVisible', IsFaqShortNameVisible.toString());
    formData.append('CreatedBy', userId || '');
    
    try {
        const token = await fetchToken();
        if(faqId != null) {
            //Update the data
            formData.append('FaqId', faqId || '');
            formData.append('UpdatedBy', userId || '');
            await axios.patch(`${API_URL}/api/Faq/UpdateFaqData`, formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            message.success('Faq updated successfully');
        }
        else{
            //Add the data
            await axios.post(`${API_URL}/api/Faq/SaveFaqData`, formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            message.success('Faq added successfully');
        }
        setFaqQuestion('');
        setFaqAnswer('');
        setFaqShortName('');
        setIsFaqShortNameVisible(false);
    } catch (error) {
        message.error('Failed to save the data');
    }
    finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div>
      <Spin spinning={loading} tip="Submitting...">
      <div>
          <Form layout="vertical" onFinish={handleSubmit}>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item label="FAQ Question" required>
                        <Input
                            value={FaqQuestion}
                            onChange={(e) => setFaqQuestion(e.target.value)}
                            placeholder="Enter FAQ Question" maxLength={1000}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item label="FAQ Answer" required>
                        <TextArea
                            value={FaqAnswer} rows={5}
                            onChange={(e) => setFaqAnswer(e.target.value)}
                            placeholder="Enter FAQ Answer" maxLength={5000}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item label="FAQ Short Name">
                        <Input
                          value={FaqShortName}
                          onChange={(e) => setFaqShortName(e.target.value)}
                          placeholder="Enter Short Name" maxLength={20}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Short Name Visible">
                        <Checkbox
                          checked={IsFaqShortNameVisible}
                          onChange={(e) => setIsFaqShortNameVisible(e.target.checked)}
                        >
                        </Checkbox>
                    </Form.Item>
                </Col>
            </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </div>
      </Spin>
    </div>
    
  );
};

export default ManageFaq;